import React from 'react'

const Women = () => {
    return (
        <div className="women container">
            <h1 className="h1">Women</h1>
        </div>
    )
}

export default Women
